import { createFileRoute } from "@tanstack/react-router";
import { routeMeta } from "@/lib/route-meta";
import PrivacyPolicy from "@/pages/PrivacyPolicy";

export const Route = createFileRoute("/privacy-policy")({ head: () => routeMeta('Privacy Policy | MNRE', 'Read how MNRE collects, uses and protects personal information.', '/privacy-policy'), component: PrivacyPolicy });
